import React from 'react';

import ReferralAccessBanner from '../../components/shared/ReferralAccessBanner/ReferralAccessBanner';
import { useReferralFlowContext } from '../../contexts/ReferralFlowContext';
import { useReferralAccess } from '../../hooks/useReferralAccess';

import { CandidateInfo } from './CandidateInfo/CandidateInfo';
import { OpeningInfo } from './OpeningInfo/OpeningInfo';
import { PersonalInfo } from './PersonalInfo/PersonalInfo';
import { Review } from './Review/Review';

export const ReferralFlow = () => {
  const { currentStep, accessOrganization } = useReferralFlowContext();
  const { blocked, pending } = useReferralAccess(accessOrganization);

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <PersonalInfo />;
      case 2:
        return <CandidateInfo />;
      case 3:
        return <OpeningInfo />;
      case 4:
        return <Review />;
      default:
        return null;
    }
  };

  return (
    <>
      <ReferralAccessBanner organization={accessOrganization} />
      {blocked && !pending ? null : renderStep()}
    </>
  );
};
